import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import $ from "jquery";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import DetailsOrg from "../DetailsOrg";
import EditOrg from "../EditOrg";
import "./ListOrg.css";
import AddOrgEmail from "../../shared/AddOrgEmail";
import { Dropdown } from "primereact/dropdown";
import ConfirmActionModal, {
  ActionType,
  ActionStatusDisplay,
} from "../../shared/ConfirmActionModal";
import useDragScroll from "../../../hooks/useDragScroll";

const ListOrg = () => {
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const {
    userRole,
    userToken,
    searchObj,
    setOrgObj,
    sharedObject,
    SetSharedObject,
    setCustomerObj,
    userSession,
    backendTarget,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    searchObj: state.searchObj,
    setOrgObj: state.setOrgObj,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    setCustomerObj: state.setCustomerObj,
    userSession: state.userSession,
    backendTarget: state.backendTarget,
  }));
  const isGcpUser = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const [gridObj, setgridObj] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [deleteConfirm, SetDeleteConfirm] = useState(false);
  const [userOrgName, setUserOrgName] = useState("List");
  const [showGridFlag, SetShowGridFlag] = useState(
    userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR"
      ? false
      : true
  );
  const [orgDetails, SetOrgDetails] = useState("");
  const [nameSearch, SetNameSearch] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const custObj = sharedObject.vendorsObj || [];
  const [expandedKeys, setExpandedKeys] = useState(null);
  const [keyFlag, SetKeyFlag] = useState(null);
  const [nrFlag, SetNrFlag] = useState(0);
  const [nrVal, SetNrVal] = useState(0);
  const [sortFlag, SetSortFlag] = useState(false);
  const [msg, SetMsg] = useState("");
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errOrgFlag, SeterrOrgFlag] = useState(false);
  const [currentOrg, SetCurrentOrg] = useState(null);
  const [custFlag, SetCustFlag] = useState(false);
  const [editObj, SetEditObj] = useState(false);
  const [showBackBtn, SetShowBackBtn] = useState(false);
  const [vendorId, SetVendorId] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showCloseOnly, SetShowCloseOnly] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedOrgForAction, setSelectedOrgForAction] = useState([]);
  const [actionSuccessFlag, setActionSuccessFlag] = useState(false);
  const [actionErrorMessage, setActionErrorMessage] = useState("");
  const tableContainerRef = useRef(null);
  useDragScroll(tableContainerRef, [gridObj]);

  const toggleApplications = (el) => {
    let _expandedKeys = { ...expandedKeys };
    if (_expandedKeys[el]) delete _expandedKeys[el];
    else _expandedKeys[el] = true;
    setExpandedKeys(_expandedKeys);
  };
  const deleteOrg = async () => {
    SetShowCloseOnly(false); 
    SetErrCreateMsg(false);
    let id = sharedObject.orgActionObj.id;
    SetProcessing(true);
    let call = "/organization/DeleteOrg?orgId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
        SetDeleteConfirm(true);
        SetShowCloseOnly(true);

      if (vendorId) {
        CustomerIdSet(vendorId + "-Name");
      } else {
        let o = { OrganizationName: nameSearch };
        OrgSearchEngine(o, false);
      }
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetMsg(str);
      SetErrCreateMsg(true);
      SetDeleteConfirm(false);
      SetProcessing(false);
      SetShowCloseOnly(true);
      }
    else if (res.status === "VALIDATIONERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
            str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
        SetErrCreateMsg(true);
        SetDeleteConfirm(false);
        SetProcessing(false);
        SetShowCloseOnly(true);
    }
  };
  const getOrganizationById = async (id, flag) => {
    SetProcessing(true);

    let call = "/organization/getOrganizationById?orgId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data.organization;
      det.tlsCertExists = res.data.data.tlsCertExists;
      det.parentList = res.data.data.parentList;
      custObj.map((elx) => {
        if (elx.id === parseInt(det.vendorId))
          SetSharedObject("CustomerPermissionsObj", elx);
      });
      SetOrgDetails(det);
      SetSharedObject("orgActionObj", det);
      SetSharedObject("CSRUploadFlag", det.tlsCertExists);
      SetSharedObject("xdrSettiingObj", det.xdrConfig);
      SetSharedObject("specialties", det.specialties);
      $("#detailsOrgModal").modal("show");
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetMsg(`<div>${res.data.message}</div>`);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
  };
  const orgSubFunc = async (obj) => {
    SetProcessing(true);
    let model = { ParentOrganizationId: obj.id };
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, model, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let arr = res.data.data;
      let fullObj = JSON.parse($("#objData").val());
      const temp = [];
      let key = obj.key;
      let dpth = obj.key.split("-");
      let child = await getOrgs(arr, key, false);

      for (const row of fullObj) {
        // IMPORTANT: cache on the original data so getOrgs() can read it later
        if (dpth.length === 1 && row.key === key) {
          row.data.subOrgCount = child.length; // < cache count
        }

        let rw = await getOrgs([row.data], false);
        rw = rw[0];
        if (dpth.length === 1 && row.key === key) {
          rw.children = child;
        }

        if (row?.children?.length > 0) {
          rw.children = row.children;
        }

        if (rw?.children?.length > 0) {
          let nr = 0;
          for (const el of rw.children) {
            if (dpth.length === 2 && el.key === key) {
              el.data.subOrgCount = child.length; // < cache count for level 2 match
            }
            let r = await getOrgs([el.data], rw.key, nr++);
            let rs = r[0];
            let eel = rs;
            if (dpth.length === 2 && el.key === key) {
              el.children = child;
              eel.children = child;
            }
            if (el?.children?.length > 0) {
              eel.children = el.children;
            }
            if (eel?.children?.length > 0) {
              let nrs = 0;
              for (const elx of eel.children) {
                if (dpth.length === 3 && elx.key === key) {
                  elx.data.subOrgCount = child.length; // < level 3
                }
                let x = await getOrgs([elx.data], eel.key, nrs++);
                let elxx = x[0];
                if (dpth.length === 3 && elx.key === key) {
                  elx.children = child;
                  elxx.children = child;
                }
                if (elx?.children?.length > 0) {
                  elxx.children = elx.children;
                }
                if (elxx?.children?.length > 0) {
                  let nrss = 0;
                  for (const four of elxx.children) {
                    if (dpth.length === 4 && four.key === key) {
                      four.data.subOrgCount = child.length; // < level 4
                    }
                    let xx = await getOrgs([four.data], elxx.key, nrss++);
                    let fourth = xx[0];
                    if (dpth.length === 4 && four.key === key) {
                      four.children = child;
                      fourth.children = child;
                    }
                    if (four?.children?.length > 0) {
                      fourth.children = four.children;
                    }
                    if (fourth?.children?.length > 0) {
                      let f = 0;
                      for (const five of fourth.children) {
                        if (dpth.length === 5 && five.key === key) {
                          five.data.subOrgCount = child.length; // < level 5
                        }
                        let xs = await getOrgs([five.data], fourth.key, f++);
                        let fivth = xs[0];
                        if (dpth.length === 5 && five.key === key) {
                          five.children = child;
                          fivth.children = child;
                        }
                        if (five?.children?.length > 0) {
                          fivth.children = five.children;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        temp.push(rw);
      }
      let str = JSON.stringify(temp);
      await $("#objData").val(str);
      await setgridObj(temp);
      await setOrgObj(temp);
      SetKeyFlag(key);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const getOrgs = async (funcObj, id, nr) => {
    SetProcessing(true);
    let tempObj = [];
    let opt =
      userSession?.CreateUserFlag ||
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR"
        ? [
            "Add User",
            "Add Org",
            "Add Org Email",
            "Activate",
            "Deactivate",
            "Delete",
          ]
        : ["Add Org", "Add Org Email", "Activate", "Deactivate", "Delete"];
    if (!isGcpUser) {
      opt = opt.filter((el) => el !== "Activate" && el !== "Deactivate");
    }
    let k = -1;
    for (const row of funcObj) {
      row.CustomerId = vendorId;
      k++;
      if (nr) k = nr;
      let childKey = id ? id + "-" + k : "" + row.id + "";
      const count = Array.isArray(row.children)
        ? row.children.length
        : row.subOrgCount || "View";

      row.showChilds = row.hasChildren ? (
        <button
         type="button"
          className="btn btn-link border-0 align-baseline"
          onClick={() => orgSubFunc(row, funcObj)}
          aria-label={`View ${count === "View" ? "sub organizations" : `${count} sub organizations`} for ${row.name || "this organization"}`}
        >
         <strong> {count}</strong>
        </button>
      ) : (
        "0"
      );
      row.key = childKey;
      //let topOrg = row.isRootOrganization ? (
      //  <i
      //    className="bi bi-star-fill sp-margin12"
      //    title="Top Level Org"
      //    alt="Top Level Org"
      //  ></i>
      //) : null;
      // PrimeReact renders the expand/collapse caret before this button and
      // indents it per tree level via inline style; the CSS in ListOrg.css
      // moves the caret after the name instead, so re-create that per-level
      // indentation here so nesting is still visible.
      let depth = childKey.split("-").length - 1;
      let cs = (
        <button
          type="button"
          className="btn btn-link border-0 align-baseline"
          style={{ marginLeft: `${depth * 16}px` }}
          onClick={(el) => {
            orgNameFunc(row);
          }}
          aria-label={`View details for organization ${row.name || "this organization"}`}
        >
          <strong>{row.name}</strong>
        </button>
      );
      row.EditCourse = cs;
      let select = (
        <select
          onChange={(el) => {
            userActions(row, el.target.value);
          }}
          id={`UserActions${row.id}`}
          value={nrVal}
          className="form-control form-control-sm p-0 ht-4"
          aria-label={`Actions for organization ${row.name || "this organization"}`}
        >
          <option value="">Select</option>
          {opt.map((el, i) => {
            return (
              <option key={i} value={el}>
                {el}
              </option>
            );
          })}
        </select>
      );
      row.dCreated = new Date(row.dateCreated);
      row.Show = true;
      row.isTopOrg = row.isRootOrganization ? 1 : 0;
      row.Actions = select;
      let o = {
        key: childKey,
        data: row,
      };
      tempObj.push(o);
    }
    SetProcessing(false);
    return tempObj;
  };
  useEffect(() => {
    SetShowBackBtn(false);
    const getOrgsObj = async (obj) => {
      let ob = await getOrgs(obj, false);
      let str = JSON.stringify(ob);
      $("#objData").val(str);
      await setgridObj(ob);
      SetShowGridFlag(true);
    };
    if (Object.keys(searchObj).length > 0) {
      if (searchObj.ShowParent === "ShowParent") {
        orgEdit(searchObj, "orgSearch");
      } else {
        SetCustFlag(false);
        getOrgsObj(searchObj);
      }
    } else {
      if (
        userRole !== "SES ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR"
      ) {
        SetVendorId(userSession.vendor_id);
        let o = { ...userSession, id: userSession.vendor_id };
        SetSharedObject("CustomerPermissionsObj", o);
        CustomerIdSet(userSession.vendor_id + "-Name");
      } else {
        let obj = sharedObject.UserIdEmail;
        if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
          if (obj.Flag !== "customer") {
            let o = { OrganizationName: obj.Name };
            OrgSearchEngine(o, obj.CustomerId);
            SetCustFlag("org");
          } else {
            SetShowBackBtn(true);
            let o = { VendorId: obj.id };
            OrgSearchEngine(o, obj.id);
            SetCustFlag("customer");
          }

          setUserOrgName(obj.Name);
          SetShowGridFlag(true);
        }
      }
    }
    SetSharedObject("AdvOrgSearchFlag", false);
  }, [searchObj]);
  useEffect(() => {
    toggleApplications(keyFlag);
  }, [keyFlag]);
  const OrgSearchEngine = async (obj, custId) => {
    SetProcessing(true);
    SetVendorId(custId);
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      SetShowGridFlag(true);
      const ob = await getOrgs(dt, false, custId);
      let str = JSON.stringify(ob);
      $("#objData").val(str);
      await setgridObj(ob);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR" || res.status === "ECONNABORTED") {
      //$(".modal").modal("hide");
      CloseModal();
      SetProcessing(false);
    }
  };
  const orgNameFunc = async (row) => {
    SetCurrentOrg(row);
    setSelectedProductId(row.key);
    let nm = "";
    sharedObject.vendorsObj.map((elx) => {
      if (elx.id === parseInt(row.vendorId)) {
        nm = elx.name;
      }
    });
    SetCustomerName(nm);
    await getOrganizationById(row.id);
  };
  const getOrganizations = async (vl, name) => {
    SetProcessing(true);
    SeterrOrgFlag(false);
    let vId = !vl ? 0 : vl;
    let call = "/organization/GetOrgsByUser?vendorId=" + vId + "&Name=" + name;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      const ob = await getOrgs(dt, false);
      let str = JSON.stringify(ob);
      $("#objData").val(str);
      await setgridObj(ob);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SeterrOrgFlag(true);
      SetProcessing(false);
    }
  };

  const orgEdit = async (val, flag, subOrgFlag) => {
    if (flag === "orgSearch") {
      if (val.ShowParent === "ShowParent") {
        await OrgSearchEngine(val, false);
      }
      await getOrganizationById(val.id);
    } else if (subOrgFlag) {
      SetShowBackBtn(true);
      setUserOrgName(val.organizationName);
      SetProcessing(true);
      let model = { ParentOrganizationId: currentOrg.id };
      let call = "/organization/OrgSearchEngine";
      const res = await CallAPI(call, model, "post", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let arr = res.data.data;
        let ob = await getOrgs(arr, false);
        let str = JSON.stringify(ob);
        $("#objData").val(str);
        await setgridObj(ob);
        SetShowGridFlag(true);
        SetProcessing(false);
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    } else {
      SetEditObj(val);
      $("#editOrgModal").modal("show");
    }
  };
  const showParent = (flag) => {
    if (flag) {
      if (sharedObject.UserIdEmail.Navigate === "email") {
        setFlag("/emails");
      } else if (sharedObject.UserIdEmail.Navigate === "customer") {
        setFlag("/customers");
      }
    } else {
      setUserOrgName("");
      SetShowBackBtn(false);
      getOrganizations(vendorId, "");
    }
  };
  const userActions = (row, type) => {
    let o = {
      ...row,
      Name: row.name,
      Type: "sub",
      OrgType: "org",
      VendorId: row.vendorId,
    };

    setCustomerObj(o);
    SetSharedObject("orgActionObj", o);
    SetSharedObject("orgActionObjForUser", o);

    if (type === "Add User") {
      navigate("/user-registration");
    } else if (type === "Add Org") {
      navigate("/organization-registration");
    } else if (type === "Add Org Email") {
      $("#AddOrgEmailModal").modal("show");
      SetNrFlag(row.id);
    } else if (type === "Delete") {
      SetNrFlag(row.id);
      SetDeleteConfirm(false);
      $("#DeleteOrg").modal("show");
      SetErrCreateMsg(false);
    } else if (type === "Activate" || type === "Deactivate") {
      setSelectedOrgForAction([row]);
      setSelectedAction(
        type === "Activate" ? ActionType.ACTIVATE : ActionType.DEACTIVATE
      );
      setActionSuccessFlag(false);
      setActionErrorMessage("");
      $("#OrgActionConfirm").modal("show");
    }
  };

  // Updates the cache ensuring changes persists through tree rebuilds
  // to fix issue with frontend-only changes lost when a row expands.
  // The issue was caused by the organization tree rebuilt from cached data
  // instead of the current in-memory data.
  const syncCachedOrgData = (updatedRow) => {
    let cached;
    try {
      cached = JSON.parse($("#objData").val() || "[]");
    } catch {
      return;
    }
    const applyUpdate = (nodes) => {
      for (const node of nodes || []) {
        if (node.key === updatedRow.key) {
          node.data.isEnabled = updatedRow.isEnabled;
          return true;
        }
        if (applyUpdate(node.children)) {
          return true;
        }
      }
      return false;
    };
    applyUpdate(cached);
    $("#objData").val(JSON.stringify(cached));
  };

  // Activate/Deactivate stays frontend-only - it only flips the locally
  // simulated `isEnabled` status, since Organization has no such column to
  // persist it to. It deliberately does NOT touch modifiedBy/dateModified:
  // those now come straight from the organization record (set for real by
  // actual edits, e.g. via Edit Org), so faking them here would misrepresent
  // this as a real update.
  const handleOrgActionConfirm = () => {
    const newIsEnabled = selectedAction === ActionType.ACTIVATE;
    for (const row of selectedOrgForAction) {
      row.isEnabled = newIsEnabled;
      syncCachedOrgData(row);
    }
    setgridObj((prev) => [...prev]);
    setActionSuccessFlag(true);
  };

  const CloseOrgActionModal = () => {
    setActionSuccessFlag(false);
    setActionErrorMessage("");
    setSelectedAction(null);
    setSelectedOrgForAction([]);
  };

  // Flags, in the confirmation modal's item list, when the selected org is
  // already in the state the chosen action would put it in.
  const orgActionConfirmItemNote = (item) => {
    if (selectedAction === ActionType.ACTIVATE && item.isEnabled !== false) {
      return `already ${ActionStatusDisplay[ActionType.ACTIVATE]}`;
    }
    if (selectedAction === ActionType.DEACTIVATE && item.isEnabled === false) {
      return `already ${ActionStatusDisplay[ActionType.DEACTIVATE]}`;
    }
    return null;
  };
  const [CustomerName, SetCustomerName] = useState("");
  const CustomerIdSet = async (val) => {
    setUserOrgName("List");

    if (val === "") {
      return;
    }
    SetSharedObject("CustomerPermissionsObj", val);
    let vl = val.split("-");
    SetCustomerName(vl[1]);
    SetVendorId(vl[0]);
    let o = { VendorId: vl[0] };
    custObj.map((elx) => {
      if (elx.id === parseInt(vl[0]))
        SetSharedObject("CustomerPermissionsObj", elx);
    });
    OrgSearchEngine(o, vl[0]);
    SetCustFlag(false);
    SetShowGridFlag(true);
  };

  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchOrg();
    }
  };
  const SearchOrg = () => {
    SetCustFlag(false);
    let o = { OrganizationName: nameSearch };
    OrgSearchEngine(o, false);
    SetShowGridFlag(true);
  };
  const handleEdit = (el) => {
    let address = el?.Addresses[0];
    gridObj.map((e) => {
      if (el.Id === e.data.id) {
        e.data.zip = address.PostalCode;
        e.data.city = address.City;
        e.data.state = address.State;
      }
    });
    getOrganizationById(currentOrg.id);
  };
  const OpenAdvSearch = async () => {
    await SetSharedObject("AdvOrgSearchFlag", true);
    $("#advOrgSearchModal").modal("show");
  };
  const nameBodyTemplate = (product) => {
    SetSortFlag(!sortFlag);
    if (sortFlag)
      gridObj.sort((a, b) => a.data.name.localeCompare(b.data.name));
    else gridObj.sort((a, b) => b.data.name.localeCompare(a.data.name));
  };
  const dateCreatedDate = (dt) => {
    return dt.data.dateCreated
      ? new Date(dt.data.dateCreated).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const lastModifiedDate = (dt) => {
    return dt.data.dateModified
      ? new Date(dt.data.dateModified).toLocaleString("en-US", {
          hour12: false,
        })
      : null;
  };
  const modifiedByDisplay = (dt) => dt.data.modifiedBy?.split("|")[0] ?? "";

  // Mirrors ListEmails' StatusDisplay: a row only reads as inactive once
  // isEnabled has explicitly been set to false; orgs that haven't been
  // activated/deactivated yet (isEnabled is undefined) read as active.
  const StatusDisplay = (dt) =>
    dt.data.isEnabled === false
      ? ActionStatusDisplay[ActionType.DEACTIVATE]
      : ActionStatusDisplay[ActionType.ACTIVATE];

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);

  const CloseModal = () => {
    SetShowCloseOnly(false); 
    SetErrCreateMsg(false);
    SetMsg("");
    SetProcessing(false);
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

    $('#DeleteOrg').modal('hide');
};

  return (
    <main className="ListOrg">
      <div className="HeaderOrgTools">
        {errOrgFlag ? (
          <div className="alert alert-danger sp-margin5 sp-margin12" role="alert" aria-live="assertive" aria-atomic="true">
            System encountered an error. Please try again. If the problem
            persists, please contact your administrator.
          </div>
        ) : null}
        <div className="HeaderTools">
          <header className="ht-6">
            {(showBackBtn || custFlag) &&
            sharedObject.UserIdEmail.Navigate !== "org" ? (
              <div className="spacer-inline btnback-container-1">
                <button
                  onClick={(el) => showParent(custFlag)}
                  aria-label="Go back to previous list"
                  className="btn btn-outline-secondary btnback sp-pad0"
                >
                  <i
                    className="bi bi-arrow-left-square-fill"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            ) : null}

            <h4 className="title-label3">
              {custFlag === "customer" ? `Customer: ${userOrgName}` : "List"}
            </h4>

            <div className="mid-header-bar" role="toolbar" aria-label="Organization search and filter options">
            {/*Search by name*/}
              <div className="spacer-inline spacer-margin5">
                <div className="input-group">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search by Name"
                    aria-label="Search organizations by name"
                    aria-describedby="SearchOrgsByNameButton"
                    value={nameSearch}
                    onChange={(el) => SetNameSearch(el.target.value)}
                    onKeyDown={SearchWithEnter}
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="SearchOrgsByNameButton"
                      onClick={SearchOrg}
                      aria-label="Search organizations"
                    >
                      <i className="bi bi-search" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              {/*Org and Customer Dropdown*/}
              <div className="OrgDropdown spacer-inline" aria-label="Organization filter options">
                  {/*Customer Dropdown List SES Admins only*/}
                  {userRole !== "SES ADMINISTRATOR" &&
                  userRole !== "SYSTEMADMINISTRATOR" ? null : (
                    <Dropdown
                      value={selectedCustomer}
                      onChange={(e) => {
                        setSelectedCustomer(e.value);
                        CustomerIdSet(e.value?.id + "-" + e.value?.name);
                      }}
                      options={custObj}
                      optionLabel="name"
                      placeholder="Customer"
                      filter
                      className="form-control w-md2 spacer-margin5"
                      ariaLabel="Select customer"
                    />
                  )}
              </div>

              {/*Advanced Search*/}
              <div className="spacer-inline">
                <button
                  className="btn btn-primary ht-2"
                  onClick={(el) => OpenAdvSearch()}
                >
                  Advanced Search
                </button>
              </div>
            </div>
          </header>
        </div>
      </div>

      {showGridFlag ? (
        <section className="grid-layout">
          <div ref={tableContainerRef} className="drag-scroll-table">
            <TreeTable
              value={gridObj}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              selectionMode="single"
              selectionKeys={selectedProductId}
              columnResizeMode="expand"
              resizableColumns
              dataKey="id"
              metaKeySelection={false}
              expandedKeys={expandedKeys}
              onToggle={(e) => setExpandedKeys(e.value)}
              sortField="dCreated"
              sortOrder={-1}
            >
              <Column
                field="isTopOrg"
                header={
                  <>
                    <i
                      className="bi bi-star-fill"
                      aria-hidden="true"
                    />
                    <span className="sr-only">Top Level Organization</span>
                  </>
                }
                className="w-sm"
                sortable
                body={(rowData) =>
                  rowData.data.isTopOrg ? (
                    <>
                      <i className="bi bi-star-fill" aria-hidden="true"></i>
                      <span className="sr-only">Top Level Organization</span>
                    </>
                  ) : null
                }
              />
              <Column
                field="EditCourse"
                header="Organization Name"
                className="OrgNameCell"
                expander
                sortable
                sortField={(e) => nameBodyTemplate(e)}
              ></Column>
              <Column
                field="showChilds"
                header="Sub Orgs"
                className="w-md3 ctr"
                sortable
              ></Column>
              { isGcpUser && (
                <Column
                  field="isEnabled"
                  header="Status"
                  className="w-md3"
                  body={StatusDisplay}
                  sortable
                ></Column>
              )}
              <Column
                field="organizationType"
                header="Type"
                className="w-md2"
                sortable
              ></Column>
              <Column
                field="city"
                header="City"
                className="w-md2"
                sortable
              ></Column>
              <Column
                field="state"
                header="State"
                className="w-md4"
                sortable
              ></Column>
              <Column
                field="zip"
                header="Zip"
                className="w-md3"
                sortable
              ></Column>
              <Column
                field="dCreated"
                header="Date Created"
                className="w-md2"
                body={dateCreatedDate}
                sortable
              ></Column>
              <Column
                field="modifiedBy"
                header="Modified By"
                className="w-md8"
                body={modifiedByDisplay}
                sortable
              ></Column>
              <Column
                field="dateModified"
                header="Last Modified"
                className="w-md2"
                body={lastModifiedDate}
                sortable
              ></Column>
              <Column field="Actions" header="Actions" className="w-md1"></Column>
            </TreeTable>
          </div>

          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <i className="bi bi-star-fill" aria-hidden="true"></i> {" "}
              <span>Top Level Organization</span>
            </div>
          </div>
        </section>
      ) : (
        <section className="empty-grid" role="status" aria-live="polite">
          There are currently no results.
        </section>
      )}
      <DetailsOrg
        orgDetails={orgDetails}
        orgEdit={orgEdit}
        customerName={CustomerName}
        CloseDetailOrg={(el) => {
          CloseModal();
        }}
      />

      <EditOrg
        editObj={editObj}
        vendorId={vendorId}
        closeEdit={(el) => handleEdit(el)}
      />

      <form hidden type="hidden">
        <input name="objData" id="objData" />
      </form>
      <AddOrgEmail />
      <ConfirmActionModal
        modalId="OrgActionConfirm"
        action={selectedAction}
        items={selectedOrgForAction}
        itemLabel={(el) => el.name}
        itemKey={(el) => el.id}
        itemNote={orgActionConfirmItemNote}
        processing={false}
        successFlag={actionSuccessFlag}
        errorMessage={actionErrorMessage}
        onConfirm={handleOrgActionConfirm}
        onClose={CloseOrgActionModal}
      />
      <div
        className="modal fade"
        id="DeleteOrg"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="deleteOrgConfirmTitle"
        aria-modal="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="deleteOrgConfirmTitle">
                Delete Confirmation
             </h3>
              <button
                type="button"
                className="close"
                aria-label="Close delete confirmation"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="descript2-container">
                {deleteConfirm ? (
                  <>
                    <div className="bi-success-check" aria-hidden="true">
                      <i
                        className="bi bi-check2-circle"
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div className="message-wrapper">
                      {`${sharedObject.orgActionObj.name} deleted successfully!`}
                    </div>
                  </>
                ) : (
                  `Please be advised that this action cannot be reversed and anything associated with this organization will not be accessible.`
                )}
              </p>
              <p className="ft-wt blk-clr ctr">
                {deleteConfirm
                  ? null
                  : `Are you sure you want to delete ${sharedObject?.orgActionObj?.name}?`}
              </p>
              {errCreateMsg ? (
                <div className={`alert alert-danger`} role="alert">
                  <div dangerouslySetInnerHTML={{ __html: msg }} />
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              {!showCloseOnly && (
                <>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={deleteOrg}
                  >
                    Confirm
                  </button>

                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={CloseModal}
                  >
                    Cancel
                  </button>
                </>
              )}

              {showCloseOnly && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                >
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      
        {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="list-org-loader"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="list-org-loader">{loadingText}</div>
            </div>
        )}
    </main>
  );
};

export default ListOrg;
